const FORMAT_APP = {
  LIMIT_PAGE: 50,
};

export default FORMAT_APP;
